/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from 'react';
import API from 'services/API';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'hooks';
import { Row } from 'components/atoms/_util';
import { Form, Input, Select } from 'components/atoms/_common';
import { useKYCUpdateStepperContext } from 'context/KYCUpdateStepper';
import { createUserKYCInternationalRequest } from 'store/slices/user';

const OtherCountries: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [KYCFields, setKYCFields] = useState(null);
  const { nextStep, setPersonalInformation, userCountry } =
    useKYCUpdateStepperContext();

  const createKYCRequest = (values: any) => {
    const onSuccess = user => {
      nextStep();
    };

    const onKYCAlreadySubmitted = () => {
      navigate('/kyc/status');
    };

    dispatch(
      createUserKYCInternationalRequest({
        onSuccess,
        onKYCAlreadySubmitted,
        values,
      })
    );
  };

  const handleSubmit = values => {
    const { NationalIdsType, NationalIds, ...rest } = values;

    let data = {};

    if (NationalIds && NationalIdsType) {
      data = {
        ...rest,
        NationalIds: { Number: NationalIds.Number, Type: NationalIdsType },
        country: userCountry,
      };
    } else {
      data = { ...rest, country: userCountry };
    }

    setPersonalInformation(data);

    createKYCRequest(data);
  };

  const getKYCFields = async (countryCodeString: string) => {
    const response = await API.get(
      `/kyc/recommended-fields?country=${countryCodeString}`
    );
    setKYCFields(response.data);
  };

  useEffect(() => {
    if (userCountry) getKYCFields(userCountry);
  }, [userCountry]);

  const renderFieldsFromGroup = (group: any, parentField?: string) => {
    if (group.title === 'NationalIds') {
      const options = group.properties.Type.enum.map((e: any) => {
        return { id: e, label: e };
      });

      return (
        <Row>
          <Input
            name="NationalIds.Number"
            label="National Id Number"
            required
          />
          <Select
            hideDefaultOption
            name="NationalIdsType"
            label="National Id Type"
            options={options}
            required
          />
        </Row>
      );
    }

    return Object.keys(group.properties).map(key => {
      const t = group.properties[key];

      if (t.properties !== undefined) {
        return renderFieldsFromGroup(t, `${group.title}.`);
      }

      if (group.required.includes(key)) {
        const max = {
          DayOfBirth: 31,
          MonthOfBirth: 12,
          YearOfBirth: new Date().getFullYear(),
        };

        return (
          <Input
            // hint={t.description || undefined}
            name={`${parentField || ''}${group.title}.${key}`}
            label={t.label}
            type={t.type === 'integer' ? 'number' : 'text'}
            placeholder={t.description || undefined}
            min={t.type === 'integer' ? 1 : undefined}
            max={max[key] || undefined}
            required
          />
        );
      }

      return null;
    });
  };

  return (
    <Form onSubmit={handleSubmit} schema={undefined}>
      {KYCFields &&
        // Map over the fields in MOCKED_DATA and render the appropriate input, only the required fields are rendered, objects that have properties inside properties should check if the properties are required
        Object.keys(KYCFields.properties).map((group: any) => {
          return renderFieldsFromGroup(KYCFields.properties[group]);
        })}

      <button type="submit" className="submit-kyc" />
    </Form>
  );
};

export default OtherCountries;
